/* Kendi Tablonu Tasarla - paylasilan render/etkilesim mantigi.
   Hem tasarim (designer) sayfasinda hem de siparis sonrasi goruntuleme (view) sayfasinda
   AYNI fonksiyonlar kullanilir, boylece onizleme ile son gorunum HER ZAMAN birebir ayni olur.
   Kompozisyon birden fazla BAGIMSIZ katmandan (layer) olusabilir - metin (text) veya sekil
   (shape) - her biri kendi konumu/boyutuyla ayri ayri surukleyip buyutulebilir.

   Sekiller, "data-part" nitelikli (outer/middle/fill) coklu-parcali SVG dosyalaridir - her
   parcanin rengi AYRI AYRI degistirilebilir (bkz. recolorShapeSvgText/recolorBackgroundSvgText). Bu, basit tek renkli
   PNG siluet boyamadan farklidir: gercek tasarimlar disari/orta/ic olmak uzere 2-3 ayri
   renk alanina sahip. */
(function (global) {
  "use strict";

  var CANVAS_W = 1000;
  var CANVAS_H = 1500;
  var PASPARTU_MARGIN_RATIO = 0.08;   // 11 Eylul 2026: 0.12 -> 0.08
  // Kullanici "paspartu cok buyuk, beyaz alan cok" dedi; secenekler
  // gosterilip %8 secildi (50 cm posterde 4 cm). pipeline.py icindeki
  // PASPARTU_BORDER_RATIO ile AYNI olmali - onceden 0.12 / 0.16 diye
  // ayriydilar ve onizleme ile urun fotografi birbirini tutmuyordu.

  var FONTS = [
    { id: "playfair", label: "Playfair Display", css: "'Playfair Display', serif" },
    { id: "poppins", label: "Poppins", css: "'Poppins', sans-serif" },
    { id: "caveat", label: "Caveat (el yazisi)", css: "'Caveat', cursive" },
    { id: "bebas", label: "Bebas Neue", css: "'Bebas Neue', sans-serif" },
    { id: "cormorant", label: "Cormorant Garamond", css: "'Cormorant Garamond', serif" },
    { id: "mono", label: "Space Mono", css: "'Space Mono', monospace" },
    // Elle boyanmis kalin poster yazisi ("more amor por favor" tarzi). Tek agirligi var (400);
    // Bebas Neue gibi, "Kalin" secildiginde tarayici sahte kalin uyguluyor.
    { id: "luckiest", label: "Luckiest Guy (el boyaması)", css: "'Luckiest Guy', cursive" },
    // Populer poster tarzlari. Hepsinin Turkce glifleri (ıİğĞşŞçÇöÖüÜ) gercek cizimle
    // dogrulandi - Google Fonts'un unicode-range bilgisi bu konuda guvenilir degil.
    { id: "abril", label: "Abril Fatface (dergi başlığı)", css: "'Abril Fatface', serif" },
    { id: "anton", label: "Anton (kalın sans)", css: "'Anton', sans-serif" },
    { id: "archivo", label: "Archivo Black (geniş kalın)", css: "'Archivo Black', sans-serif" },
    { id: "bowlby", label: "Bowlby One SC (poster harfi)", css: "'Bowlby One SC', sans-serif" },
    { id: "yellowtail", label: "Yellowtail (eğik fırça)", css: "'Yellowtail', cursive" },
    { id: "josefin", label: "Josefin Sans (art deco)", css: "'Josefin Sans', sans-serif" },
    { id: "cinzel", label: "Cinzel (klasik büyük harf)", css: "'Cinzel', serif" },
    { id: "parisienne", label: "Parisienne (zarif el yazısı)", css: "'Parisienne', cursive" },
    { id: "pacifico", label: "Pacifico (retro el yazısı)", css: "'Pacifico', cursive" },
    { id: "amaticsc", label: "Amatic SC (uzun el yazısı)", css: "700 'Amatic SC', cursive" }
  ];

  var COLORS = [
    "#1a1a1a", "#ffffff", "#6b6b6b", "#9b9b9b",
    "#c0392b", "#e0703a", "#d9a441", "#8a8a3c",
    "#5b8c5a", "#2f6f6a", "#1e2638", "#4a6fa5",
    "#7d5ba6", "#c56a9e", "#8a5a44", "#e8ddc9"
  ];

  var WEIGHTS = [
    { id: "thin", label: "İnce", css: "400" },
    { id: "bold", label: "Kalın", css: "700" }
  ];

  // Klavyede olmayan, poster yazilarinda sik kullanilan sembol/ikonlar - metin kutusunun
  // yanindaki sembol satirindan tek tikla eklenir.
  // Geometrik olanlar (kare/yuvarlak/dikdortgen/ucgen) icli-dolu ve ici bos ciftler halinde durur.
  var SYMBOLS = ["♥", "❤", "♡", "★", "☆", "✦", "✧", "■", "□", "●", "○", "▬", "▭", "▲", "△", "✓", "✕", "☀", "☁", "☺", "♪", "♫", "❁", "✿", "➤", "∞", "•", "⚘"];

  var SHAPE_ROLE_LABELS = { outer: "Dış Renk", middle: "Çizgi Rengi", fill: "İç Renk" };
  var DEFAULT_SHAPE_COLORS = { outer: "#F4A7C5", middle: "#FF6B2C", fill: "#F8D8E5" };

  var BG_ROLE_LABELS = {
    background: "Zemin Rengi",
    pattern: "Desen Rengi",
    "pattern-mid": "Desen (Orta Ton)",
    "pattern-dark": "Desen (Koyu Ton)",
    "color-1": "Renk 1",
    "color-2": "Renk 2",
    "color-3": "Renk 3",
    "color-4": "Renk 4"
  };
  function bgRoleLabel(part) {
    return BG_ROLE_LABELS[part] || part;
  }

  function loadGoogleFonts() {
    if (document.getElementById("cp-google-fonts")) return;
    var link = document.createElement("link");
    link.id = "cp-google-fonts";
    link.rel = "stylesheet";
    link.href =
      "https://fonts.googleapis.com/css2?" +
      "family=Playfair+Display:ital,wght@0,400;0,700;1,400;1,700" +
      "&family=Poppins:ital,wght@0,400;0,700;1,400;1,700" +
      "&family=Caveat:ital,wght@0,400;0,700" +
      "&family=Bebas+Neue" +
      "&family=Cormorant+Garamond:ital,wght@0,400;0,700;1,400;1,700" +
      "&family=Space+Mono:ital,wght@0,400;0,700;1,400;1,700" +
      "&family=Luckiest+Guy" +
      "&family=Abril+Fatface" +
      "&family=Anton" +
      "&family=Archivo+Black" +
      "&family=Bowlby+One+SC" +
      "&family=Yellowtail" +
      "&family=Josefin+Sans:ital,wght@0,400;0,700;1,400;1,700" +
      "&family=Cinzel:wght@400;700" +
      "&family=Parisienne" +
      "&family=Pacifico" +
      "&family=Amatic+SC:wght@400;700" +
      "&display=swap";
    document.head.appendChild(link);
  }

  function fontCssById(id) {
    for (var i = 0; i < FONTS.length; i++) {
      if (FONTS[i].id === id) return FONTS[i].css;
    }
    return FONTS[0].css;
  }

  function weightCssById(id) {
    for (var i = 0; i < WEIGHTS.length; i++) {
      if (WEIGHTS[i].id === id) return WEIGHTS[i].css;
    }
    return "700";
  }

  function layerFontString(layer, fontSize) {
    return (layer.italic ? "italic " : "") + weightCssById(layer.weight) + " " + fontSize + "px " + fontCssById(layer.font);
  }

  var _uid = 0;
  function newLayerId() {
    _uid += 1;
    return "l" + Date.now().toString(36) + _uid;
  }

  var PLACEHOLDER_TEXT = "Yazınızı buraya yazın";

  function defaultLayer(overrides) {
    var layer = {
      id: newLayerId(),
      type: "text",
      text: "",
      font: FONTS[0].id,
      weight: "bold",
      italic: false,
      color: COLORS[0],
      x: 0.5,
      y: 0.5,
      scale: 1,
      rotation: 0
    };
    for (var k in overrides || {}) layer[k] = overrides[k];
    return layer;
  }

  function defaultShapeLayer(overrides) {
    var layer = {
      id: newLayerId(),
      type: "shape",
      shapeUrl: "",
      shapeLabel: "",
      parts: ["outer", "fill"],
      colors: {
        outer: DEFAULT_SHAPE_COLORS.outer,
        middle: DEFAULT_SHAPE_COLORS.middle,
        fill: DEFAULT_SHAPE_COLORS.fill
      },
      x: 0.5,
      y: 0.5,
      scale: 1,
      scaleY: 1,
      rotation: 0
    };
    for (var k in overrides || {}) {
      if (k === "colors") {
        layer.colors = Object.assign({}, layer.colors, overrides.colors);
      } else {
        layer[k] = overrides[k];
      }
    }
    return layer;
  }

  function defaultState() {
    return {
      bg: "",
      bgLabel: "",
      bgParts: [],
      bgColors: {},
      paspartu: false,
      size: "",
      layers: [defaultLayer()]
    };
  }

  function parsePosterSize(sizeLabel) {
    var match = String(sizeLabel || "").match(/(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)/i);
    if (!match) return null;

    var width = parseFloat(match[1].replace(",", "."));
    var height = parseFloat(match[2].replace(",", "."));
    if (!isFinite(width) || !isFinite(height) || width <= 0 || height <= 0) return null;
    return { width: width, height: height };
  }

  function greatestCommonDivisor(a, b) {
    a = Math.abs(Math.round(a));
    b = Math.abs(Math.round(b));
    while (b) {
      var remainder = a % b;
      a = b;
      b = remainder;
    }
    return a || 1;
  }

  function posterRatioLabel(sizeLabel) {
    var size = parsePosterSize(sizeLabel);
    if (!size) return "2:3 dikey";

    var roundedW = Math.round(size.width);
    var roundedH = Math.round(size.height);
    var divisor = greatestCommonDivisor(roundedW, roundedH);
    var ratio = Math.abs(size.width / size.height - 1) < 0.001
      ? "1:1"
      : (roundedW / divisor) + ":" + (roundedH / divisor);
    var direction = Math.abs(size.width / size.height - 1) < 0.001
      ? "kare"
      : (size.width > size.height ? "yatay" : "dikey");
    return ratio + " " + direction;
  }

  function canvasDimensionsForSize(sizeLabel) {
    var size = parsePosterSize(sizeLabel);
    if (!size) {
      return { width: CANVAS_W, height: CANVAS_H, label: posterRatioLabel("") };
    }

    var longestEdge = 1500;
    var scale = longestEdge / Math.max(size.width, size.height);
    return {
      width: Math.max(1, Math.round(size.width * scale)),
      height: Math.max(1, Math.round(size.height * scale)),
      label: posterRatioLabel(sizeLabel)
    };
  }

  function encodeState(state) {
    var params = new URLSearchParams();
    params.set("bg", state.bg || "");
    params.set("bgLabel", state.bgLabel || "");
    params.set("bgParts", (state.bgParts || []).join(","));
    params.set("bgColors", (state.bgParts || []).map(function (p) { return (state.bgColors || {})[p] || ""; }).join(","));
    params.set("paspartu", state.paspartu ? "1" : "0");
    params.set("size", state.size || "");
    params.set(
      "layers",
      JSON.stringify(
        (state.layers || []).map(function (l) {
          if (l.type === "shape") {
            return [
              "shape", l.shapeUrl, l.shapeLabel, (l.parts || []).join(","),
              l.colors.outer, l.colors.middle, l.colors.fill,
              +l.x.toFixed(4), +l.y.toFixed(4), +l.scale.toFixed(3), +(l.rotation || 0).toFixed(0),
              +(Number(l.scaleY) > 0 ? Number(l.scaleY) : 1).toFixed(3)
            ];
          }
          return [
            "text", l.text, l.font, l.weight, l.italic ? 1 : 0, l.color,
            +l.x.toFixed(4), +l.y.toFixed(4), +l.scale.toFixed(3), +(l.rotation || 0).toFixed(0)
          ];
        })
      )
    );
    return params.toString();
  }

  function decodeState(search) {
    var params = new URLSearchParams(search);
    var s = defaultState();
    if (params.has("bg")) s.bg = params.get("bg");
    if (params.has("bgLabel")) s.bgLabel = params.get("bgLabel");
    if (params.has("bgParts")) {
      s.bgParts = params.get("bgParts").split(",").filter(Boolean);
      var bgColorVals = (params.get("bgColors") || "").split(",");
      s.bgColors = {};
      s.bgParts.forEach(function (p, i) {
        if (bgColorVals[i]) s.bgColors[p] = bgColorVals[i];
      });
    }
    if (params.has("paspartu")) s.paspartu = params.get("paspartu") === "1";
    if (params.has("size")) s.size = params.get("size");
    if (params.has("layers")) {
      try {
        var raw = JSON.parse(params.get("layers"));
        if (Array.isArray(raw) && raw.length) {
          s.layers = raw.map(function (arr) {
            if (arr[0] === "shape") {
              return defaultShapeLayer({
                shapeUrl: arr[1], shapeLabel: arr[2], parts: (arr[3] || "").split(",").filter(Boolean),
                colors: { outer: arr[4], middle: arr[5], fill: arr[6] },
                x: arr[7], y: arr[8], scale: arr[9], rotation: Number(arr[10]) || 0,
                scaleY: Number(arr[11]) > 0 ? Number(arr[11]) : 1
              });
            }
            return defaultLayer({
              text: arr[1], font: arr[2], weight: arr[3], italic: !!arr[4], color: arr[5],
              x: arr[6], y: arr[7], scale: arr[8], rotation: Number(arr[9]) || 0
            });
          });
        }
      } catch (e) {
        /* bozuk link - varsayilan tek katmanla devam et */
      }
    }
    return s;
  }

  function wrapLines(ctx, text, maxWidth) {
    var paragraphs = String(text || "").split(/\r?\n/);
    var lines = [];
    paragraphs.forEach(function (para) {
      var words = para.split(/\s+/).filter(Boolean);
      if (words.length === 0) {
        lines.push("");
        return;
      }
      var current = words[0];
      for (var i = 1; i < words.length; i++) {
        var test = current + " " + words[i];
        if (ctx.measureText(test).width <= maxWidth) {
          current = test;
        } else {
          lines.push(current);
          current = words[i];
        }
      }
      lines.push(current);
    });
    return lines;
  }

  function measureTextLayerBox(ctx, layer, innerW) {
    var fontSize = Math.round(innerW * 0.09 * layer.scale);
    ctx.font = layerFontString(layer, fontSize);
    var maxWidth = innerW * 0.86;
    var lines = wrapLines(ctx, layer.text, maxWidth);
    var lineHeight = fontSize * 1.25;
    var boxW = 0;
    lines.forEach(function (l) {
      boxW = Math.max(boxW, ctx.measureText(l).width);
    });
    var boxH = lineHeight * lines.length;
    return { fontSize: fontSize, lines: lines, lineHeight: lineHeight, boxW: boxW, boxH: boxH };
  }

  // ---- Sekil (SVG, coklu parca renklendirme) ----

  var _svgTextCache = {};
  function fetchSvgText(url) {
    if (_svgTextCache[url]) return _svgTextCache[url];
    _svgTextCache[url] = fetch(url).then(function (r) {
      if (!r.ok) throw new Error("SVG yuklenemedi: " + url);
      return r.text();
    });
    return _svgTextCache[url];
  }

  // SVG kaynaklari sadece viewBox tasiyor, width/height yok - bazi tarayicilar boyle bir
  // <img>'i dusuk bir varsayilan boyutta (orn. 300x150) rasterize edip sonra buyutunce
  // PIKSELLESTIREBILIYOR. Vektorun HER buyutme/kucultme adiminda (canvas'a cizilirken) net
  // kalmasini garantilemek icin, viewBox'in EN/BOY ORANINI koruyarak buyuk, sabit bir
  // intrinsik piksel boyutu atiyoruz.
  var SVG_RASTER_LONG_EDGE = 1800;

  function _setSvgIntrinsicSize(root, longEdge) {
    var vb = (root.getAttribute("viewBox") || "").trim().split(/\s+/).map(Number);
    if (vb.length === 4 && vb[2] > 0 && vb[3] > 0) {
      var scale = longEdge / Math.max(vb[2], vb[3]);
      root.setAttribute("width", Math.round(vb[2] * scale));
      root.setAttribute("height", Math.round(vb[3] * scale));
    } else {
      root.setAttribute("width", longEdge);
      root.setAttribute("height", longEdge);
    }
  }

  // Bir SVG'de data-part="X" nitelikli TUM elementleri (birden fazla olabilir - orn. arka
  // plandaki onlarca puanto/desen elementi hepsi ayni "pattern" rolunu paylasir) verilen
  // renkle boyar. <stop> elementleri icin stop-color, digerleri icin fill kullanilir.
  function _applySvgPartColors(doc, colors) {
    Object.keys(colors || {}).forEach(function (part) {
      var color = colors[part];
      if (!color) return;
      var els = doc.querySelectorAll('[data-part="' + part + '"]');
      els.forEach(function (el) {
        if (el.tagName.toLowerCase() === "stop") el.setAttribute("stop-color", color);
        else el.setAttribute("fill", color);
      });
    });
  }

  function recolorShapeSvgText(svgText, colors) {
    var doc = new DOMParser().parseFromString(svgText, "image/svg+xml");
    var root = doc.documentElement;
    _setSvgIntrinsicSize(root, SVG_RASTER_LONG_EDGE);
    _applySvgPartColors(doc, colors);
    // Sekle ozel: "fill" parcasinin uzerinde bir stroke (ayirici cizgi) varsa, ayri bir
    // data-part="middle" elementi olmasa bile bu cizgi "middle" rengiyle boyanir.
    if (colors && colors.middle) {
      var fillEl = doc.querySelector('[data-part="fill"]');
      if (fillEl && fillEl.hasAttribute("stroke")) fillEl.setAttribute("stroke", colors.middle);
    }
    return new XMLSerializer().serializeToString(doc.documentElement);
  }

  function recolorBackgroundSvgText(svgText, colors) {
    var doc = new DOMParser().parseFromString(svgText, "image/svg+xml");
    var root = doc.documentElement;
    _setSvgIntrinsicSize(root, SVG_RASTER_LONG_EDGE);
    _applySvgPartColors(doc, colors);
    return new XMLSerializer().serializeToString(doc.documentElement);
  }

  function _dataUriImage(svgString) {
    var dataUri = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(svgString);
    return new Promise(function (resolve, reject) {
      var img = new Image();
      img.onload = function () {
        resolve(img);
      };
      img.onerror = function () {
        reject(new Error("SVG gorseli olusturulamadi"));
      };
      img.src = dataUri;
    });
  }

  function shapeImageKey(layer) {
    var c = layer.colors || {};
    return layer.shapeUrl + "|" + (c.outer || "") + "," + (c.middle || "") + "," + (c.fill || "");
  }

  function loadTintedShapeImage(layer) {
    return fetchSvgText(layer.shapeUrl).then(function (svgText) {
      return _dataUriImage(recolorShapeSvgText(svgText, layer.colors || {}));
    });
  }

  function bgImageKey(bg, bgColors) {
    if (!bg.parts || !bg.parts.length) return bg.url;
    return bg.url + "|" + bg.parts.map(function (p) { return (bgColors || {})[p] || ""; }).join(",");
  }

  function loadTintedBackgroundImage(bg, bgColors) {
    return fetchSvgText(bg.url).then(function (svgText) {
      return _dataUriImage(recolorBackgroundSvgText(svgText, bgColors || {}));
    });
  }

  /**
   * Kompozisyonu bir canvas'a cizer. bgImage null olabilir (henuz yuklenmemis).
   * shapeImages: { [shapeImageKey(layer)]: HTMLImageElement } - sekil katmanlari icin
   * ONCEDEN renklendirilip yuklenmis gorseller (yuklenmemis bir sekil sessizce atlanir).
   * Donen deger: { innerX, innerY, innerW, innerH, layerBoxes: [{ id, cx, cy, w, h, handleX, handleY }] }
   */
  function drawComposition(ctx, W, H, state, bgImage, shapeImages, opts) {
    shapeImages = shapeImages || {};
    var showPlaceholders = !opts || opts.showPlaceholders !== false;
    ctx.clearRect(0, 0, W, H);
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, W, H);

    var margin = state.paspartu ? Math.round(W * PASPARTU_MARGIN_RATIO) : 0;
    var innerX = margin,
      innerY = margin,
      innerW = W - margin * 2,
      innerH = H - margin * 2;

    if (bgImage) {
      var scale = Math.max(innerW / bgImage.width, innerH / bgImage.height);
      var sw = innerW / scale,
        sh = innerH / scale;
      var sx = (bgImage.width - sw) / 2,
        sy = (bgImage.height - sh) / 2;
      ctx.save();
      ctx.beginPath();
      ctx.rect(innerX, innerY, innerW, innerH);
      ctx.clip();
      ctx.drawImage(bgImage, sx, sy, sw, sh, innerX, innerY, innerW, innerH);
      ctx.restore();
    } else {
      ctx.fillStyle = "#e5e5e5";
      ctx.fillRect(innerX, innerY, innerW, innerH);
    }

    if (state.paspartu) {
      ctx.strokeStyle = "rgba(0,0,0,0.08)";
      ctx.lineWidth = 2;
      ctx.strokeRect(innerX, innerY, innerW, innerH);
    }

    var layerBoxes = [];
    (state.layers || []).forEach(function (layer) {
      var rotation = Number(layer.rotation) || 0;
      var rotationRad = (rotation * Math.PI) / 180;
      if (layer.type === "shape") {
        var img = shapeImages[shapeImageKey(layer)];
        if (!img) return;
        var baseSize = innerW * 0.4 * layer.scale;
        var aspect = (img.naturalHeight || img.height || 1) / (img.naturalWidth || img.width || 1);
        // scaleY: sekli YALNIZ dikeyde gerer (6 Eylul 2026). Yoksa 1, yani
        // eski tasarimlar birebir ayni cizilir.
        var esnek = Number(layer.scaleY) > 0 ? Number(layer.scaleY) : 1;
        var boxW = baseSize,
          boxH = baseSize * aspect * esnek;
        var cx = innerX + innerW * layer.x;
        var cy = innerY + innerH * layer.y;
        ctx.save();
        ctx.translate(cx, cy);
        ctx.rotate(rotationRad);
        ctx.drawImage(img, -boxW / 2, -boxH / 2, boxW, boxH);
        ctx.restore();
        layerBoxes.push({
          id: layer.id, cx: cx, cy: cy, w: boxW, h: boxH, rotation: rotation
        });
        return;
      }

      var hasText = layer.text && layer.text.trim();
      if (!hasText && !showPlaceholders) return;
      var drawLayer = hasText ? layer : Object.assign({}, layer, { text: PLACEHOLDER_TEXT });
      var m = measureTextLayerBox(ctx, drawLayer, innerW);
      var tcx = innerX + innerW * layer.x;
      var tcy = innerY + innerH * layer.y;

      ctx.save();
      ctx.translate(tcx, tcy);
      ctx.rotate(rotationRad);
      ctx.font = layerFontString(layer, m.fontSize);
      ctx.fillStyle = hasText ? layer.color : "rgba(26,26,26,0.35)";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";

      var startY = -(m.boxH - m.lineHeight) / 2;
      m.lines.forEach(function (line, i) {
        ctx.fillText(line, 0, startY + i * m.lineHeight);
      });
      ctx.restore();

      layerBoxes.push({
        id: layer.id, cx: tcx, cy: tcy, w: m.boxW, h: m.boxH, rotation: rotation
      });
    });

    return { innerX: innerX, innerY: innerY, innerW: innerW, innerH: innerH, layerBoxes: layerBoxes };
  }

  function loadImage(url) {
    return new Promise(function (resolve, reject) {
      if (!url) {
        resolve(null);
        return;
      }
      var img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = function () {
        resolve(img);
      };
      img.onerror = function () {
        reject(new Error("Gorsel yuklenemedi: " + url));
      };
      img.src = url;
    });
  }

  // ---- Cerceveli onizleme (duz siyah cerceve, ahsap DEGIL) ----
  // Tasarimci sayfasinin en altina "Cercevede onizle" dugmesi ve tam ekran onizleme
  // penceresi ekler. Dugme/pencere/stil TAMAMEN buradan uretiliyor; tema Liquid, CSS ve
  // custom-poster-designer.js dosyalarina DOKUNULMUYOR (Codex o dosyalarda calisiyor).
  // Cerceve olculeri gercek "Framelle Basic Cerceve" fotografina bakilarak secildi:
  // ince, mat siyah ahsap, paspartusuz - baski cerceveye tam oturuyor.
  var MOCKUP_FRAME_RATIO = 0.07;   // cerceve kalinligi: posterin KISA kenarinin %7'si
  var MOCKUP_LONG_EDGE = 860;      // onizleme tuvalinin uzun kenari (CSS piksel)

  // Canli onizleme tuvaline tasarimci ayrica SECIM CERCEVESI ve buyutme tutamaci ciziyor
  // (custom-poster-designer.js -> drawSelectionUI). O tuvali oldugu gibi kopyalarsak kesik
  // cizgili kutu ve tutamac cerceveli onizlemeye de girer. Bu yuzden asagidaki sarmalayici
  // her cizimde son kompozisyonun girdilerini hatirlar; onizleme bunlari kullanarak posteri
  // TEMIZ olarak yeniden cizer. Boylece designer.js dosyasina dokunmak gerekmiyor.
  var sonKompozisyon = null;

  function drawCompositionKayitli(ctx, W, H, state, bgImage, shapeImages, opts) {
    var sonuc = drawComposition(ctx, W, H, state, bgImage, shapeImages, opts);
    var hedef = ctx && ctx.canvas;
    if (hedef && hedef.hasAttribute && hedef.hasAttribute("data-cp-canvas")) {
      sonKompozisyon = { W: W, H: H, state: state, bgImage: bgImage, shapeImages: shapeImages };
    }
    return sonuc;
  }

  // Seçim arayüzü olmayan, baskıya giden hâliyle poster. Kayıt yoksa (beklenmedik durum)
  // görünen tuvale geri düşer - özellik hiç çalışmamaktansa tutamaçlı çalışsın.
  function temizPosterKaynagi(gorunenCanvas) {
    if (!sonKompozisyon) return gorunenCanvas;
    try {
      var off = document.createElement("canvas");
      off.width = sonKompozisyon.W;
      off.height = sonKompozisyon.H;
      drawComposition(
        off.getContext("2d"), off.width, off.height,
        sonKompozisyon.state, sonKompozisyon.bgImage, sonKompozisyon.shapeImages,
        { showPlaceholders: false }
      );
      return off;
    } catch (e) {
      return gorunenCanvas;
    }
  }

  function mockupStyles() {
    return [
      ".cp-mockup-bar{margin-top:22px;padding-top:18px;border-top:1px solid rgba(0,0,0,.10);text-align:center}",
      ".cp-mockup-open{display:inline-flex;align-items:center;gap:9px;padding:13px 24px;min-height:46px;",
      "border:1px solid #16161a;border-radius:11px;background:#16161a;color:#fff;font:inherit;",
      "font-size:.95rem;font-weight:600;cursor:pointer;transition:opacity .12s ease}",
      ".cp-mockup-open:hover{opacity:.86}",
      ".cp-mockup-hint{margin:9px 0 0;font-size:.8rem;color:#6b6b6b}",
      ".cp-mockup-overlay{position:fixed;inset:0;z-index:9999;display:flex;align-items:center;",
      "justify-content:center;padding:18px;background:rgba(18,16,14,.72);overflow:auto}",
      ".cp-mockup-panel{position:relative;max-width:min(94vw,760px);width:100%;max-height:94vh;",
      "background:#fff;border-radius:16px;padding:20px 20px 16px;box-shadow:0 24px 60px rgba(0,0,0,.32)}",
      // Dikey posterlerde tuval ekrandan tasmasin: hem genislik hem YUKSEKLIK sinirlandirilir.
      // aspect-ratio JS tarafinda verildigi icin width/height:auto ile tarayici oraniyla sigdirir.
      ".cp-mockup-panel canvas{display:block;margin:0 auto;max-width:100%;",
      "max-height:calc(94vh - 190px);width:auto;height:auto;border-radius:8px}",
      // Sagdaki bosluk, baslik satirinin kapatma dugmesinin altina girmesini engeller.
      ".cp-mockup-head{display:flex;align-items:baseline;justify-content:space-between;gap:12px;",
      "margin:0 0 14px;padding-right:44px}",
      ".cp-mockup-title{margin:0;font-size:1.02rem;font-weight:700}",
      ".cp-mockup-size{font-size:.85rem;color:#6b6b6b}",
      ".cp-mockup-note{margin:12px 0 0;font-size:.78rem;color:#6b6b6b;line-height:1.45}",
      ".cp-mockup-close{position:absolute;top:10px;right:10px;width:38px;height:38px;border:0;",
      "border-radius:50%;background:rgba(0,0,0,.06);color:#16161a;font-size:1.25rem;line-height:1;",
      "cursor:pointer}",
      ".cp-mockup-close:hover{background:rgba(0,0,0,.12)}",
      "@media (max-width:600px){.cp-mockup-panel{padding:16px 14px 12px}}"
    ].join("");
  }

  function ensureMockupStyles() {
    if (document.getElementById("cp-mockup-styles")) return;
    var st = document.createElement("style");
    st.id = "cp-mockup-styles";
    st.textContent = mockupStyles();
    document.head.appendChild(st);
  }

  // Siyah ahsap cerceveyi ve duvar zeminini cizer, posteri icine oturtur.
  /* Cerceve paleti (Claude, 12 Eylul 2026). Beyazda pah yonleri TERS:
     siyahta dis pah acik / ic pah koyu; beyazda govde zaten acik oldugu
     icin dis pah neredeyse saf beyaz, ic pah belirgin koyu olmali. */
  var MOCKUP_PALET = {
    siyah: { golge: "#17140f", g0: "#231e18", g1: "#14110d", g2: "#211c16",
             damar: "#5a4c3c", damarAlfa: 0.16,
             disPah: "rgba(255,255,255,.13)", icPah: "rgba(0,0,0,.55)",
             dusenGolge: "rgba(35,28,22,.34)" },
    beyaz: { golge: "#d7d2c9", g0: "#fcfcfa", g1: "#eeebe5", g2: "#f8f6f2",
             damar: "#cdc6ba", damarAlfa: 0.13,
             disPah: "rgba(255,255,255,.75)", icPah: "rgba(0,0,0,.26)",
             dusenGolge: "rgba(90,80,68,.30)" },
    /* RENKLI BASIC CERCEVELER (23 Eylul 2026, kullanici: "posterini tasarla
       yerinde renkli cerceveler yok"). Tonlar urun sayfasindaki renk
       noktalariyla ayni ailede: govde orta ton, disPah acik, icPah koyu. */
    ceviz:   { golge: "#2f1512", g0: "#6b3128", g1: "#40201c", g2: "#5c2b23",
               damar: "#8d5a45", damarAlfa: 0.18,
               disPah: "rgba(255,255,255,.16)", icPah: "rgba(0,0,0,.5)",
               dusenGolge: "rgba(48,26,20,.34)" },
    kirmizi: { golge: "#7d080e", g0: "#d3242a", g1: "#9c0b12", g2: "#c2141b",
               damar: "#e8615f", damarAlfa: 0.14,
               disPah: "rgba(255,255,255,.22)", icPah: "rgba(0,0,0,.42)",
               dusenGolge: "rgba(90,14,18,.32)" },
    pembe:   { golge: "#b45a8d", g0: "#e58cbd", g1: "#c05c96", g2: "#d97cae",
               damar: "#f3b9d6", damarAlfa: 0.16,
               disPah: "rgba(255,255,255,.45)", icPah: "rgba(0,0,0,.3)",
               dusenGolge: "rgba(120,60,95,.28)" },
    sari:    { golge: "#c99c00", g0: "#ffd83a", g1: "#e0ab00", g2: "#f5c707",
               damar: "#fff0a8", damarAlfa: 0.18,
               disPah: "rgba(255,255,255,.5)", icPah: "rgba(0,0,0,.28)",
               dusenGolge: "rgba(130,100,10,.28)" }
  };

  /* Secili cerceve rengi urun formundaki "Çerçeve" seceneginden okunuyor.
     Urunde o secenek yoksa (eski durum) siyah varsayiliyor. */
  function seciliCerceve() {
    var girdiler = document.querySelectorAll(
      'input[type="radio"]:checked, select option:checked');
    for (var i = 0; i < girdiler.length; i++) {
      var d = (girdiler[i].value || "").trim();
      if (d.indexOf("Beyaz") === 0) return "beyaz";
      if (d.indexOf("Siyah") === 0) return "siyah";
      // Renkli Basic cerceveler (23 Eylul 2026). Degerler tam eslesir;
      // "Kırmızı" icin lower() KULLANILMIYOR (Turkce I tuzagi).
      if (d === "Ceviz") return "ceviz";
      if (d === "Kırmızı") return "kirmizi";
      if (d === "Pembe") return "pembe";
      if (d === "Sarı") return "sari";
    }
    return "siyah";
  }

  function drawFramedMockup(canvas, poster, renk) {
    var P = MOCKUP_PALET[renk || seciliCerceve()] || MOCKUP_PALET.siyah;
    var oran = poster.width / poster.height;
    var pw = oran >= 1 ? MOCKUP_LONG_EDGE : Math.round(MOCKUP_LONG_EDGE * oran);
    var ph = oran >= 1 ? Math.round(MOCKUP_LONG_EDGE / oran) : MOCKUP_LONG_EDGE;
    var fw = Math.max(9, Math.round(Math.min(pw, ph) * MOCKUP_FRAME_RATIO));
    var bosluk = Math.round(Math.max(pw, ph) * 0.13);   // duvar payi
    var W = pw + fw * 2 + bosluk * 2;
    var H = ph + fw * 2 + bosluk * 2;

    var dpr = Math.min(global.devicePixelRatio || 1, 2);
    canvas.width = Math.round(W * dpr);
    canvas.height = Math.round(H * dpr);
    canvas.style.aspectRatio = W + " / " + H;
    var ctx = canvas.getContext("2d");
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

    // Duvar
    ctx.fillStyle = "#efeae3";
    ctx.fillRect(0, 0, W, H);
    var isik = ctx.createRadialGradient(W * 0.42, H * 0.3, 10, W * 0.5, H * 0.5, Math.max(W, H) * 0.78);
    isik.addColorStop(0, "rgba(255,255,255,.55)");
    isik.addColorStop(1, "rgba(120,105,92,.16)");
    ctx.fillStyle = isik;
    ctx.fillRect(0, 0, W, H);

    var fx = bosluk, fy = bosluk;
    var fW = pw + fw * 2, fH = ph + fw * 2;

    // Cerceve golgesi
    ctx.save();
    ctx.shadowColor = P.dusenGolge;
    ctx.shadowBlur = Math.round(fw * 2.6);
    ctx.shadowOffsetY = Math.round(fw * 0.85);
    ctx.fillStyle = P.golge;
    ctx.fillRect(fx, fy, fW, fH);
    ctx.restore();

    // Ahsap yuzey: hafif dikey damar
    var ahsap = ctx.createLinearGradient(fx, fy, fx + fW, fy + fH);
    ahsap.addColorStop(0, P.g0);
    ahsap.addColorStop(0.45, P.g1);
    ahsap.addColorStop(1, P.g2);
    ctx.fillStyle = ahsap;
    ctx.fillRect(fx, fy, fW, fH);
    ctx.save();
    ctx.globalAlpha = P.damarAlfa;
    ctx.strokeStyle = P.damar;
    ctx.lineWidth = 1;
    for (var g = 0; g < fW; g += 5) {
      var kayma = ((g * 37) % 11) - 5;
      ctx.beginPath();
      ctx.moveTo(fx + g, fy);
      ctx.lineTo(fx + g + kayma, fy + fH);
      ctx.stroke();
    }
    ctx.restore();

    // Ic ve dis pah (cerceveye hacim verir)
    ctx.strokeStyle = P.disPah;
    ctx.lineWidth = 1.5;
    ctx.strokeRect(fx + 0.75, fy + 0.75, fW - 1.5, fH - 1.5);
    ctx.strokeStyle = P.icPah;
    ctx.strokeRect(fx + fw - 0.75, fy + fw - 0.75, pw + 1.5, ph + 1.5);

    // Poster
    ctx.drawImage(poster, fx + fw, fy + fw, pw, ph);

    // Baskinin cerceveye degdigi yerdeki ic golge
    var ig = ctx.createLinearGradient(fx + fw, fy + fw, fx + fw + Math.min(pw, ph) * 0.05, fy + fw + Math.min(pw, ph) * 0.05);
    ig.addColorStop(0, "rgba(0,0,0,.20)");
    ig.addColorStop(1, "rgba(0,0,0,0)");
    ctx.fillStyle = ig;
    ctx.fillRect(fx + fw, fy + fw, pw, ph);
  }

  function seciliOlcu(root) {
    var sec = root.querySelector("[data-cp-size]");
    if (!sec) return "";
    var ham = "";
    if (sec.selectedOptions && sec.selectedOptions.length) ham = sec.selectedOptions[0].textContent;
    else ham = sec.value || "";
    ham = ham.trim();
    // Varyant basligi "20x30 - 700.00 TRY" seklinde geliyor; cerceve onizlemesinde fiyat
    // degil yalniz olcu gosterilir. Ayirici yoksa metin oldugu gibi kalir.
    var kesme = ham.split(" - ")[0].trim();
    return kesme || ham;
  }

  function openMockup(root) {
    var poster = root.querySelector("[data-cp-canvas]");
    if (!poster) return;

    var overlay = document.createElement("div");
    overlay.className = "cp-mockup-overlay";
    overlay.setAttribute("role", "dialog");
    overlay.setAttribute("aria-modal", "true");
    overlay.setAttribute("aria-label", "Çerçeveli önizleme");

    var panel = document.createElement("div");
    panel.className = "cp-mockup-panel";

    var head = document.createElement("div");
    head.className = "cp-mockup-head";
    var baslik = document.createElement("p");
    baslik.className = "cp-mockup-title";
    baslik.textContent = "Siyah Çerçeve";
    var olcu = document.createElement("span");
    olcu.className = "cp-mockup-size";
    olcu.textContent = seciliOlcu(root);
    head.appendChild(baslik);
    head.appendChild(olcu);

    var kapat = document.createElement("button");
    kapat.type = "button";
    kapat.className = "cp-mockup-close";
    kapat.setAttribute("aria-label", "Kapat");
    kapat.textContent = "×";

    var tuval = document.createElement("canvas");
    var not = document.createElement("p");
    not.className = "cp-mockup-note";
    not.textContent = "Tasarımın siyah çerçevede böyle görünür. "
      + "Poster ölçüsünü yukarıdaki adımdan seçebilirsin; bu görsel temsilidir.";

    panel.appendChild(kapat);
    panel.appendChild(head);
    panel.appendChild(tuval);
    panel.appendChild(not);
    overlay.appendChild(panel);
    document.body.appendChild(overlay);

    drawFramedMockup(tuval, temizPosterKaynagi(poster));
    /* Cerceve secimi degisince onizlemeyi tazele (Claude, 12 Eylul 2026).
       Tek sefer baglaniyor; yoksa her cizimde yeni dinleyici birikiyordu. */
    if (!document.documentElement.hasAttribute("data-cp-cerceve-dinleyici")) {
      document.documentElement.setAttribute("data-cp-cerceve-dinleyici", "1");
      document.addEventListener("change", function (e) {
        // 2 Ekim 2026: renkli cercevelerde de tazele (eskiden yalniz Siyah/Beyaz).
        if (e.target && /^cp-cerceve/.test(e.target.name || "")) {
          try { drawFramedMockup(tuval, temizPosterKaynagi(poster)); } catch (x) {}
        }
      }, true);
    }

    function kapatPencere() {
      if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
      document.removeEventListener("keydown", esc);
    }
    function esc(e) {
      if (e.key === "Escape") kapatPencere();
    }
    kapat.addEventListener("click", kapatPencere);
    overlay.addEventListener("click", function (e) {
      if (e.target === overlay) kapatPencere();
    });
    document.addEventListener("keydown", esc);
    kapat.focus();
  }

  function initMockup() {
    var root = document.querySelector("[data-cp-designer]");
    if (!root || root.querySelector(".cp-mockup-bar")) return;
    if (!root.querySelector("[data-cp-canvas]")) return;
    ensureMockupStyles();

    var bar = document.createElement("div");
    bar.className = "cp-mockup-bar";
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "cp-mockup-open";
    btn.innerHTML = '<span aria-hidden="true">🖼</span><span>Çerçevede önizle</span>';
    var ipucu = document.createElement("p");
    ipucu.className = "cp-mockup-hint";
    ipucu.textContent = "Tasarımını çerçevede gör";
    bar.appendChild(btn);
    bar.appendChild(ipucu);
    root.appendChild(bar);

    btn.addEventListener("click", function () {
      openMockup(root);
    });
  }

  global.CustomPoster = {
    CANVAS_W: CANVAS_W,
    CANVAS_H: CANVAS_H,
    FONTS: FONTS,
    COLORS: COLORS,
    WEIGHTS: WEIGHTS,
    SYMBOLS: SYMBOLS,
    SHAPE_ROLE_LABELS: SHAPE_ROLE_LABELS,
    DEFAULT_SHAPE_COLORS: DEFAULT_SHAPE_COLORS,
    bgRoleLabel: bgRoleLabel,
    loadGoogleFonts: loadGoogleFonts,
    fontCssById: fontCssById,
    weightCssById: weightCssById,
    newLayerId: newLayerId,
    defaultLayer: defaultLayer,
    defaultShapeLayer: defaultShapeLayer,
    defaultState: defaultState,
    parsePosterSize: parsePosterSize,
    posterRatioLabel: posterRatioLabel,
    canvasDimensionsForSize: canvasDimensionsForSize,
    encodeState: encodeState,
    decodeState: decodeState,
    shapeImageKey: shapeImageKey,
    loadTintedShapeImage: loadTintedShapeImage,
    bgImageKey: bgImageKey,
    loadTintedBackgroundImage: loadTintedBackgroundImage,
    drawComposition: drawCompositionKayitli,
    loadImage: loadImage,
    initMockup: initMockup
  };

  // Cerceveli onizleme baslatma - MUTLAKA disa aktarimdan SONRA ve try/catch icinde.
  // Boylece bu ek ozellikte bir hata cikarsa tasarimcinin geri kalani calismaya devam eder.
  function guvenliMockupInit() {
    try {
      initMockup();
    } catch (e) {
      if (global.console && console.warn) console.warn("[custom-poster] cerceveli onizleme kurulamadi:", e);
    }
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", guvenliMockupInit);
  } else {
    guvenliMockupInit();
  }
})(window);
